package com.devi3east.bashbuddy.auth

sealed interface AuthDialogStep {
    data object SignIn : AuthDialogStep
    data object Success : AuthDialogStep
}